export default "__VITE_ASSET__I4$xoV9O__"